import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "uf-daterange-picker" }
const _hoisted_2 = { class: "uf-daterange-picker__header van-hairline--bottom" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, "开始日期", -1)
const _hoisted_4 = { class: "uf-daterange-picker__start-value" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, "结束日期", -1)
const _hoisted_6 = { class: "uf-daterange-picker__end-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "bottom",
      "lazy-render": "",
      "safe-area-inset-bottom": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "uf-daterange-picker__header-cancel",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, "取消"),
          _createElementVNode("i", {
            class: "uf-daterange-picker__header-clear",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
          }, "清空"),
          (_ctx.isLongTerm)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(["uf-daterange-picker__header-long-term", { 'uf-daterange-picker__header-active': _ctx.longTermActive }]),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLongTerm && _ctx.onLongTerm(...args)))
              }, "长期", 2))
            : _createCommentVNode("", true),
          _createElementVNode("i", {
            class: "uf-daterange-picker__header-confirm",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args)))
          }, "确定")
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["uf-daterange-picker__start", { 'uf-daterange-picker--active': _ctx.currentPicker === 'start' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentPicker = 'start'))
        }, [
          _hoisted_3,
          _createElementVNode("i", _hoisted_4, _toDisplayString(_ctx.startDate), 1)
        ], 2),
        (!_ctx.longTermActive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["uf-daterange-picker__end", { 'uf-daterange-picker--active': _ctx.currentPicker === 'end' }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentPicker = 'end'))
            }, [
              _hoisted_5,
              _createElementVNode("i", _hoisted_6, _toDisplayString(_ctx.endDate), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.currentPicker === 'start')
          ? (_openBlock(), _createBlock(_component_van_datetime_picker, {
              key: 1,
              modelValue: _ctx.start,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.start) = $event)),
              type: _ctx.type,
              "show-toolbar": false,
              "min-date": _ctx.minDate,
              "max-date": _ctx.startDateMaxDate
            }, null, 8, ["modelValue", "type", "min-date", "max-date"]))
          : _createCommentVNode("", true),
        (_ctx.currentPicker === 'end')
          ? (_openBlock(), _createBlock(_component_van_datetime_picker, {
              key: 2,
              modelValue: _ctx.end,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.end) = $event)),
              type: _ctx.type,
              "show-toolbar": false,
              "min-date": _ctx.endMinDate,
              "max-date": _ctx.maxDate
            }, null, 8, ["modelValue", "type", "min-date", "max-date"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}